import styled from 'styled-components'
import { Page, PageContent } from 'src/components/Page'
import Gap from 'lib/components/Gap'
import { links } from 'src/links'
import { useAuth } from 'lib/auth/useAuth'
import Heading from '@kiwicom/orbit-components/lib/Heading'
import { useRouter } from 'next/router'
import BetterLink from 'src/components/BetterLink'
import { prefetchUserAndVideos, useUserQuery } from 'src/queries/users'
import PageLoader from 'src/components/PageLoader'
import UserDetail from 'src/components/UserDetail'
import dataFormatter, { formatCollection } from 'src/utils/dataFormatter'
import { Box, Button, Stack, Tag, Text, TextLink } from '@kiwicom/orbit-components'
import { linkKeys, skillsLabels, videoTypesLabels } from 'models/user'
import ContentBox from 'src/components/ContentBox'
import Col from 'lib/components/Col'
import Row from 'lib/components/Row'
import Icon from 'src/components/Icon'
import { capitalizeFirstLetter } from 'lib/strings'
import VideoCard, { VideosWrapper } from 'src/components/VideoCard'
import { prefetchVideo, prefetchVideos, useVideoQuery, useVideosQuery } from 'src/queries/videos'
import ProfileImage from 'src/components/ProfileImage'
import BetterModal from 'src/components/BetterModal'
import SEO from 'src/components/SEO'
import { createBasicServerSideProps } from 'lib/next'
import { Loader } from 'src/components/Loader'
import VideoDetail, { useVideoDetail } from 'src/components/VideoDetail'

const VideoDetailPage = ({ ...props }) => {
  const router = useRouter()
  const {
    query: { nanoid },
  } = router

  const { data, isLoading, isSuccess, isError, ...rest } = useVideoQuery(nanoid, {
    enabled: !!nanoid,
  })

  const video = dataFormatter(data, 'video')

  // const { data: user } = useUserQuery(data?.author?.slug, {
  //   enabled: !!data?.author?.slug,
  // })

  // console.log('rest', rest, data, isSuccess, isError)
  // todo - dořešit, co tedy kde bude vidět za data
  if (isLoading || !data) {
    return <PageLoader />
  }

  if (isError) {
    return (
      <PageLoader.Error title="Uživatel nebyl nalezen">
        Zkuste ho otevřít znovu. Pokud problém přetrvává, obraťte se na naší podporu. Děkujeme.
      </PageLoader.Error>
    )
  }

  // console.log('user data', user)

  // console.log('video2', video)
  return (
    <>
      <SEO title={`${video.name} | Referenční videa`} />
      <Page bg="cloudLight">
        <PageContent>
          <VideoDetail
            video={video}
            user={video.author}
            onClose={() => {
              router.push({
                pathname: links.CREATOR_PUBLIC_DETAIL,
                query: { slug: video.author.slug },
              })
            }}
          />
          <Gap gap="24px" />
          <BetterLink href={links.VIDEOS}>Zobrazit všechna videa</BetterLink>
          <Gap gap="80px" />
        </PageContent>
      </Page>
    </>
  )
}

export default VideoDetailPage

VideoDetailPage.protected = false

// TODO: seo
export const getServerSideProps = createBasicServerSideProps({
  prefetchQueriesWithParams: [prefetchVideo(query => query)],
})
